<template>
  <v-form v-model="valid" ref="DialogForm">
    <slotted-dialog
      :title="isNotNew ? ($t('servicesystem.common_objects.lead.lead') + ' #' + editObject.Id) : $t('servicesystem.common_objects.lead.new_lead')"
      :externaltrigger="dialogtrigger" :externalCloseTrigger="closetrigger">

      <template v-slot:content>
        <v-container fluid :key="dialogtrigger">
          <p class="mb-0" style="color: var(--v-ThemeText-lighten2);">
            {{ $t('servicesystem.common_objects.commonterms.context') }}
          </p>
          <LeadRelationBar v-if="isNotNew" :item="editObject" class="my-2">
          </LeadRelationBar>
          <template v-else>
            <CustomerSelect v-model="editObject.CustomerId" class="mb-3" clearable :loading="false" externaledit>
            </CustomerSelect>
            <JobSelect v-model="editObject.JobId" class="mb-3" clearable :loading="false" externaledit>
            </JobSelect>
            <MachineSelect v-model="editObject.Machine" returnobject clearable class="mb-3" :loading="false"
              externaledit>
            </MachineSelect>
          </template>

          <v-divider class="mb-3"></v-divider>

          <v-row no-gutters class="mb-3">
            <v-col :cols="isPhoneBool ? 12 : 6">
              <LeadStateControl v-model="editObject.State" dense edit noempty>
              </LeadStateControl>
            </v-col>
            <v-col :cols="isPhoneBool ? 12 : 6">
              <LeadTypeSelect v-model="editObject.LeadTypeId" externaledit hideIcon allowCreate>
              </LeadTypeSelect>
            </v-col>
          </v-row>

          <QTextArea v-model="editObject.Note" :key="dialogtrigger"
            :timestampOnFirstLineEnter="globalSettings.OnEnterUserTimestampLeadNote"
            :label="$t('servicesystem.common_objects.lead.note')" externaledit :rules="[requiredRule]" clearable
            class="mb-6 mt-3">
          </QTextArea>

          <v-row no-gutters v-if="isNotNew">
            <v-col cols="4">
              <p class="mb-0" style="color: var(--v-ThemeText-lighten2);">
                {{ $t('servicesystem.common_objects.job.creator') }}
              </p>
              <UserChip v-if="editObject.CreatedBy" :user="editObject.CreatedBy" :index="0" :typecolored="true">
              </UserChip>
              <p v-else class="mb-0">?</p>
            </v-col>
            <v-col cols="4">
              <QTextField v-if="editObject.CreatedDate" :value="i18nFormatDateTime(editObject.CreatedDate)"
                :label="$t('servicesystem.common_objects.job.created')" disabled>
              </QTextField>
            </v-col>
            <v-col cols="4"
              v-if="editObject.CreatedDate && editObject.Modified && (editObject.CreatedDate != editObject.Modified)">
              <QTextField :value="i18nFormatDateTime(editObject.Modified)"
                :label="$t('servicesystem.common_objects.job.modified')" disabled>
              </QTextField>
            </v-col>
          </v-row>
        </v-container>
      </template>

      <template v-slot:buttons>
        <v-btn @click="closetrigger++" color="primary" outlined>
          {{ $t('servicesystem.common_objects.commonterms.cancel') }}
        </v-btn>
        <v-btn @click="valid ? handleSave() : null" :loading="loading" :disabled="loading"
          :color="valid ? 'primary' : 'disabled'">
          {{ isNotNew ? $t('servicesystem.common_objects.commonterms.save') :
            $t('servicesystem.common_objects.commonterms.create') }}
        </v-btn>
      </template>

    </slotted-dialog>
  </v-form>
</template>


<script>
import clientAPI from "@/api/ClientAPIMixin.js";
import UserChip from "@/components/Buttons/UserChip.vue";
import CustomerSelect from "@/components/Inputs/EntityDropdowns/CustomerSelect2.vue";
import JobSelect from "@/components/Inputs/EntityDropdowns/JobSelect2.vue";
import LeadTypeSelect from "@/components/Inputs/EntityDropdowns/LeadTypeSelect2.vue";
import MachineSelect from "@/components/Inputs/EntityDropdowns/MachineSelect2.vue";
import LeadStateControl from "@/components/LeadStateControl.vue";
import SlottedDialog from "@/views/layouts/SlottedDialog.vue";
import LeadRelationBar from "./LeadRelationBar.vue";

export default {
  name: "LeadDialog",
  props: {
    externaltrigger: [Number, Boolean],
    item: Object,
  },
  components: {
    SlottedDialog,
    CustomerSelect,
    JobSelect,
    MachineSelect,
    LeadTypeSelect,
    LeadRelationBar,
    UserChip,
    LeadStateControl,
  },
  mixins: [clientAPI],

  data() {
    return {
      dialogtrigger: 1,
      closetrigger: 1,
      editObject: {},
      valid: false,
      loading: false,
    };
  },

  mounted() {
    this.parseItem();
  },

  methods: {
    handleSave() {
      this.loading = true;
      this.isNotNew ? this.save("changeLead", "Changed") : this.save("createLead", "Added");
    },

    save(methodname, emitEventName) {
      var dto = Object.assign({}, this.editObject);

      clientAPI.methods[methodname](dto)
        .then((response) => {
          response.new = true;

          this.$emit(emitEventName, response);
          this.closetrigger++;
        })
        .catch(() => { })
        .finally(() => {
          this.loading = false;
        });
    },

    parseItem() {
      this.editObject = Object.assign({}, this.item);
    },
  },

  computed: {
    isNotNew() {
      return !!this.editObject.Id;
    },

    globalSettings() {
      return this.$store.state.GlobalSettings;
    },
  },

  watch: {
    externaltrigger: function () {
      this.parseItem();
      this.dialogtrigger++;
    },
  },
};
</script>